import React from "react";
import { AutoComplete } from "antd";

const DataListComponent = props => {
  const options = props.data.map((item) => {
    const label =
      props.label === "Reviewer"
        ? item.first_name.length > 20
          ? item.first_name.slice(0, 20) + ".."
          : item.first_name
        : item.name.length > 20
          ? item.name.slice(0, 20) + ".."
          : item.name;

    return {
      value: item.id.toString(),
      label: `${item.id} - ${label}`,
      item,
    };
  });

  return (
    <div className="d-flex flex-column justify-content-between">
      <label className="text-black font-w600">Choose {props.label}</label>

      <AutoComplete
        options={options}
        value={props.value}
        onChange={(value) => props.searchTextChange(props.label, value)}
        onSelect={(value, option) =>
          props.filterChange(props.label, value, option.item)
        }
        filterOption={false}
      >
        <input className="form-control" />
      </AutoComplete>
    </div>
  );
};

export default DataListComponent;
